import React from "react";
import CategoryPage from "./CategoryPage";

function StateArticle({
  posts,
  publications
}) {

  return (
    <CategoryPage
      title="State"
      parentCategory="Articles"
      posts={posts}
      publications={publications}
    />
  );

}

export default StateArticle;